export default {
      id: "icon-yorum-yok-usage",
      viewBox: "0 0 614.5 179.5",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-yorum-yok",
      toString: function () {
        return this.url;
      }
    }